import React from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { useAuth, useModal } from "../../context";
import styles from "./editProfileForm.module.css";

const EditProfileForm = () => {
  const { editUserData, setEditUserData, handleUpdate } = useAuth();
  const { setIsEditProfileModal } = useModal();
  const handleOnClickUpdate = () => {
    handleUpdate();
    setIsEditProfileModal((prev) => !prev);
  };
  return (
    <div className={styles.editProfileForm__wrapper}>
      <div className={styles.coverImage__wrapper}>
        {editUserData.coverImage && (
          <img
            className={styles.coverImage__img}
            src={URL.createObjectURL(editUserData.coverImage)}
            alt="coverImage"
          />
        )}
        {editUserData.coverImage ? (
          <button
            onClick={() =>
              setEditUserData((prev) => ({
                ...prev,
                coverImage: "",
              }))
            }
            className={styles.remove__button}
          >
            <IoMdCloseCircle size="1.5rem" title="remove" />
          </button>
        ) : (
          <input
            type="file"
            accept="image/png, image/jpeg"
            className={styles.coverImage__input}
            onChange={(e) =>
              setEditUserData((prev) => ({
                ...prev,
                coverImage: e.target.files[0],
              }))
            }
          />
        )}
      </div>
      <div className={styles.avatar__wrapper}>
        {editUserData.avatar && (
          <img
            className={styles.avatar__img}
            src={URL.createObjectURL(editUserData.avatar)}
            alt="avatar"
          />
        )}
        {editUserData.avatar ? (
          <button
            onClick={() =>
              setEditUserData((prev) => ({
                ...prev,
                avatar: "",
              }))
            }
            className={styles.remove__button}
          >
            <IoMdCloseCircle size="1.5rem" title="remove" />
          </button>
        ) : (
          <input
            type="file"
            name="avatar"
            accept="image/png, image/jpeg"
            className={styles.avatar__input}
            onChange={(e) =>
              setEditUserData((prev) => ({
                ...prev,
                avatar: e.target.files[0],
              }))
            }
          />
        )}
      </div>
      <div className={styles.accountDetails__wrapper}>
        <div>
          <label htmlFor="email" className="input-label">
            Email:
          </label>
          <input
            id="email"
            type="email"
            className="form-field border-radius-xs padding-xs"
            placeholder="email"
            required
            onChange={(e) =>
              setEditUserData((prev) => ({ ...prev, email: e.target.value }))
            }
            value={editUserData.email}
          />
        </div>
        <div>
          <label htmlFor="fullname" className="input-label">
            FullName:
          </label>
          <input
            id="fullname"
            type="text"
            className="form-field border-radius-xs padding-xs"
            placeholder="fullname"
            required
            onChange={(e) =>
              setEditUserData((prev) => ({ ...prev, fullName: e.target.value }))
            }
            value={editUserData.fullName}
          />
        </div>
      </div>
      <div className={styles.button__wrapper}>
        <button
          className="btn btn-primary border-radius-xs"
          onClick={handleOnClickUpdate}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default EditProfileForm;
